module.exports = __webpack_public_path__ + "static/media/picto-green-fixed.5af6477b.png";